import CreateSetupBackend from "../config/config.js";
import { isMutual } from "../../utils/isMutual.jsx";

let SetupBackend = null;

function create(data) {
  SetupBackend = CreateSetupBackend();
  if (isMutual()) {
    const email = sessionStorage.getItem("emailUser");
    const amount = Number(data?.amount || 0);
    const payload = {
      pixKey: data?.key,
      amount: {
        currency: "BRL",
        value: amount.toFixed(2),
      },
      description: data?.additionalInformation || "",
    };

    return SetupBackend.post(
      `/v1/baas/pix-static-qrcodes?email=${email}`,
      payload,
    ).then((res) => {
      const qrCodePayload =
        res?.data?.qrcodeData ||
        res?.data?.qrcode ||
        res?.data?.emvqrcps ||
        res?.data?.body?.qrcodeData ||
        res?.data?.body?.qrcode ||
        res?.data?.body?.emv ||
        res?.data?.body?.copyAndPaste ||
        res?.data?.emv ||
        res?.data?.qrCode ||
        res?.data?.copyAndPaste ||
        "";

      const qrCodeImageBase64 =
        res?.data?.qrcodeImageBase64 ||
        res?.data?.body?.qrcodeImageBase64 ||
        res?.data?.qrCodeImageBase64 ||
        "";

      return {
        ...res,
        data: {
          ...(res?.data || {}),
          emvqrcps: qrCodePayload,
          qrcodeImageBase64: qrCodeImageBase64,
        },
      };
    });
  }

  return SetupBackend.post("/v1/pix/cashin/static/create", data);
}

function index(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(`/v1/pix/cashin/static/index/${data.transactionid}`);
}

function show(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(`/v1/pix/cashin/static/show/${data.transactionid}`);
}

function showBase64(data) {
  SetupBackend = CreateSetupBackend();
  return SetupBackend.get(
    `/v1/pix/cashin/static/showbase64/${data.transactionid}?pixelsPerModule=${data.pixelsPerModule}&imageType=${data.imageType}`,
  );
}

const backendServices = {
  create,
  index,
  show,
  showBase64,
};

export default backendServices;
